<template>
    <transition name="overlay">
    <div v-if="open" class="recovery-overlay" @click.self="dismiss">
        <div class="recovery-card" role="dialog" aria-modal="true" :aria-labelledby="titleId">
            <div class="recovery-head">
                <div class="recovery-badge" aria-hidden="true">
                    <img :src="badgeIcon" alt="" width="20" height="20" />
                </div>
                <h2 :id="titleId" class="recovery-title">{{ title }}</h2>
                <p class="recovery-body">{{ body }}</p>
            </div>

            <div class="recovery-footer">
                <template v-if="variant === 'email_unverified'">
                    <button type="button" class="recovery-btn recovery-btn-ghost" @click="go('change-email')">{{ t('users-prompt-other_email') }}</button>
                    <button type="button" class="recovery-btn recovery-btn-primary" @click="go('confirm-email')">{{ t('users-prompt-confirm_email') }}</button>
                </template>
                <template v-else-if="variant === 'phone_unverified'">
                    <button type="button" class="recovery-btn recovery-btn-ghost" @click="go('change-phone')">{{ t('users-prompt-other_phone') }}</button>
                    <button type="button" class="recovery-btn recovery-btn-primary" @click="go('confirm-phone')">{{ t('users-prompt-confirm_phone') }}</button>
                </template>
                <template v-else>
                    <button type="button" class="recovery-btn recovery-btn-ghost" @click="go('add-phone')">{{ t('users-prompt-add_phone') }}</button>
                    <button type="button" class="recovery-btn recovery-btn-primary" @click="go('add-email')">{{ t('users-prompt-add_email') }}</button>
                </template>
            </div>

            <button type="button" class="recovery-btn-later" @click="dismiss">{{ t('users-prompt-later') }}</button>
        </div>
    </div>
    </transition>
</template>

<script>
import keviApi from "../../keviApi";

export default {
    name: "recovery-prompt",
    data() {
        return {
            open: false,
            variant: null,
            email: "",
            phone: "",
            titleId: "recovery-prompt-title",
            loaded: false,
        };
    },
    computed: {
        badgeIcon() {
            if (this.variant === "email_unverified") return "images/icons/mail-02-amber.svg";
            if (this.variant === "phone_unverified") return "images/icons/phone-amber.svg";
            return "images/icons/shield-off.svg";
        },
        title() {
            if (this.variant === "email_unverified") return this.t("users-prompt-email_title");
            if (this.variant === "phone_unverified") return this.t("users-prompt-phone_title");
            return this.t("users-prompt-no_contact_title");
        },
        body() {
            if (this.variant === "email_unverified") {
                return this.t("users-prompt-email_body", { 0: this.email });
            }
            if (this.variant === "phone_unverified") {
                return this.t("users-prompt-phone_body", { 0: this.phone });
            }
            return this.t("users-prompt-no_contact_body");
        },
    },
    created() {
        this.load();
    },
    watch: {
        "$route.path"() {
            if (this.$route.path === "/") {
                this.open = false;
                return;
            }
            // Montado ainda na tela de login: carrega assim que o usuário entra no app.
            if (!this.loaded) this.load();
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        load() {
            if (!this.$store.state.user || !this.$store.state.user.token) return;
            if (this.$route.path === "/") return;
            this.loaded = true;
            this.$http(keviApi.getOptions("account/profile")).then((response) => {
                const variant = response.body.prompt_variant;
                if (!variant) return;
                this.variant = variant;
                this.email = response.body.prompt_email || response.body.email || "";
                this.phone = response.body.prompt_phone || response.body.phone || "";
                this.open = true;
            });
        },
        go(action) {
            this.open = false;
            this.$router.push({ path: "/account", query: { action: action } });
        },
        dismiss() {
            this.open = false;
            this.$http(keviApi.getOptions("account/recovery-prompt/dismiss", "POST", {}));
        },
    },
};
</script>

<style scoped>
.recovery-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 17, 31, 0.5);
    z-index: 80;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    box-sizing: border-box;
}
.recovery-card {
    background: #fff;
    border: 1px solid #e5e6eb;
    border-radius: 16px;
    width: 100%;
    max-width: 560px;
    padding: 16px;
    box-sizing: border-box;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    transition: transform .24s cubic-bezier(.16, 1, .3, 1), opacity .2s ease;
}
.overlay-enter-active, .overlay-leave-active { transition: opacity .2s ease; }
.overlay-enter, .overlay-leave-to { opacity: 0; }
.overlay-enter .recovery-card,
.overlay-leave-to .recovery-card {
    opacity: 0;
    transform: translateY(12px) scale(.98);
}
.recovery-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
    text-align: center;
}
.recovery-badge {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    background: #fff7d4;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    overflow: hidden;
}
.recovery-badge img {
    width: 20px;
    height: 20px;
    display: block;
}
.recovery-title,
.recovery-body {
    text-box-trim: trim-both;
    text-box-edge: cap alphabetic;
}
.recovery-title {
    margin: 0;
    width: 100%;
    font-family: "Sora", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.3;
    color: #1f2337;
}
.recovery-body {
    margin: 0;
    width: 100%;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: #626473;
}
.recovery-body >>> strong {
    font-weight: 500;
    color: #383c50;
}
.recovery-footer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
}
.recovery-btn,
.recovery-btn-later {
    margin: 0;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    line-height: 1.2;
    cursor: pointer;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
}
.recovery-btn {
    flex: 1 0 0;
    min-width: 0;
    min-height: 43px;
    padding: 12px;
    border-radius: 8px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color .15s ease, border-color .15s ease;
}
.recovery-btn-primary {
    border: 0;
    background: #2AAA4C;
    color: #f1fcf3;
}
.recovery-btn-primary:hover { background: #249643; }
.recovery-btn-ghost {
    border: 1px solid #e5e6eb;
    background: #fafafc;
    color: #383c50;
}
.recovery-btn-ghost:hover { background: #f3f3f6; }
.recovery-btn-later {
    width: 100%;
    min-height: 28px;
    padding: 4px;
    border: 0;
    border-radius: 0;
    background: transparent;
    color: #383c50;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-box-trim: trim-both;
    text-box-edge: cap alphabetic;
}
.recovery-btn-later:hover { opacity: 0.75; }

@media (max-width: 559px) {
    .recovery-head { gap: 12px; }
    .recovery-footer {
        flex-direction: column;
        align-items: stretch;
    }
    .recovery-btn {
        width: 100%;
        flex: none;
    }
}
</style>
